export default __webpack_public_path__ + "static/media/social.cc48db96.png";